import { ICycle } from 'models/cycle/cycle.model';

import api from '../api';

export const getCycleById = async ({ queryKey }): Promise<ICycle> => {
	const [, id] = queryKey;
	const filters = [
		{
			column_name: 'id',
			values: +id,
			value_type: 'number',
			operation: 'equal',
		},
	];
	const pagination = {
		page: 0,
		size: 1,
	};
	const response = await api.post(`/ciclo/view`, {
		pagination,
		filters,
	});
	return response.data?.data[0];
};
